import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { CatHeading } from '@blocks-react/components/Heading';
export const NotificationOrderStatusCheckbox = ({ label, handleChange, value, orderStatusValue }) => {
    const checkedStatus = useMemo(() => !!orderStatusValue &&
        orderStatusValue?.some((d) => d.orderStatus === value.value), [orderStatusValue, value]);
    return (_jsx("div", { className: "mb-2", children: _jsx(CatCheckboxField, { checked: checkedStatus, name: label, id: label, "data-testid": label, onBlCheckboxChange: (e) => handleChange(e, value), children: _jsx(CatHeading, { variant: "body-sm", "aria-label": label, children: label }) }) }));
};
